import { Card } from "flowbite-react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { UPLOAD } from "../../routes/routes";
import { useContext, useMemo } from "react";
import { UploadContext } from "../../context/UploadProvider";
import {
  C_DIVIDEND_FEED,
  C_LEGAL_DOCUMENTS,
  C_TRADING_HOURS,
} from "../../constants/types";
import { CategoryObj } from "../../helpers/fileUploader/objects";

const CATEGORY_METADATA_KEYS = new Set([
  "category",
  "createdAt",
  "file",
  "file_name",
  "user_id",
]);

export const Dashboard = () => {
  const location = useLocation();
  const { data, isLoading } = useContext(UploadContext);

  //get total file count of each category
  const countNestedFiles = (categoryObject) => {
    let totalCount = 0;
    for (const key in categoryObject) {
      if (!categoryObject.hasOwnProperty(key)) continue;
      if (
        CATEGORY_METADATA_KEYS.has(key) ||
        typeof categoryObject[key] !== "object" ||
        categoryObject[key] === null
      ) {
        continue;
      }
      totalCount += Object.keys(categoryObject[key]).length;
    }
    return totalCount;
  };

  //update later
  const uploadCount = (value) => {
    if (data[0] && data[0][value]) {
      if (value === C_LEGAL_DOCUMENTS) {
        return countNestedFiles(data[0][value]);
      } else if (value === C_TRADING_HOURS) {
        let count = Object.keys(data[0][value]).length;
        return count > 0 ? count - 1 : 0;
      } else if (value === C_DIVIDEND_FEED) {
        return 1;
      } else {
        return Object.keys(data[0][value]).length;
      }
    } else {
      return 0;
    }
  };

  const sortedCategories = useMemo(() => {
    const categories = CategoryObj();

    if (isLoading || !data?.[0]) {
      return categories;
    }

    return [...categories].sort((a, b) => {
      const aDate = data[0][a.value]?.createdAt;
      const bDate = data[0][b.value]?.createdAt;

      const aTime = aDate ? new Date(aDate).getTime() : 0;
      const bTime = bDate ? new Date(bDate).getTime() : 0;

      return bTime - aTime;
    });
  }, [data, isLoading]);

  return (
    <div className="container">
      <div className="max-w-full mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-16 sm:flex sm:items-start sm:justify-center">
        {location.pathname === `/${UPLOAD}` ||
        location.pathname === `/${UPLOAD}/` ? (
          <div className="grid gap-2 sm:gap-6 lg:grid-cols-3 sm:grid-cols-2 w-full">
            {sortedCategories.map((item, index) => {
              return (
                <Link
                  key={index}
                  to={`/${UPLOAD}/${item.routes}`}
                  state={{ title: item.title, value: item.value }}
                  className="hover:shadow-lg"
                >
                  <Card>
                    <div className="flex justify-between">
                      <h3 className="text-lg font-semibold tracking-tight  dark:text-white">
                        {item.title}
                      </h3>
                      <div className="text-xs text-gray-500">
                        Last Updated
                        {!isLoading && data?.[0]?.[item.value]?.createdAt && (
                          <div className="font-medium text-gray-800">
                            {new Date(
                              data[0][item.value].createdAt,
                            ).toLocaleDateString()}
                          </div>
                        )}
                      </div>
                    </div>
                    {!isLoading ? (
                      <>
                        <div className="mt-6">
                          <div className="text-3xl font-bold text-gray-900">
                            {uploadCount(item.value)}
                          </div>

                          <div className="text-sm text-gray-500">
                            Uploaded Files
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className="h-6 w-6 animate-spin rounded-full border-[3px] border-gray-200 border-t-[#008f36]" />
                    )}
                  </Card>
                </Link>
              );
            })}
          </div>
        ) : (
          <Outlet />
        )}
      </div>
    </div>
  );
};
